(function () {
    if (customElements.get('pcard-color-swatch')) return
    function getIsPc() {
        return !FoxTheme?.config.mqlMobile && !FoxTheme?.config.mqlTablet
    }

    function findEleByClass(ele, className) {
        if (ele === document.body || !ele) return null
        if (ele.className.indexOf?.(className) >= 0) return ele
        return findEleByClass(ele.parentElement, className)
    }

    function handleColorListMouseMove(ele) {
        let isMouseDown = false
        let didDrag = false
        let lastPageX = null
        const moveEle = ele.querySelector('.swatches--product-card')
        if (!moveEle || !moveEle.children?.length) return

        const parentEle = moveEle.parentElement
        const eleForArrow = parentEle.parentElement

        function measureMaxDiff() {
            // 用真实 scrollWidth，避免 flex 收缩后 children.clientWidth * n 算不出溢出
            const contentWidth = moveEle.scrollWidth
            const viewWidth = parentEle.clientWidth
            return Math.min(0, viewWidth - contentWidth)
        }

        let maxDiff = measureMaxDiff()
        let translateX = 0
        let ancestor = findEleByClass(ele, 'product-card__swatches-container') || ele
        let isPC = getIsPc()

        const handleBodyMove = (e) => {
            e.stopPropagation()
        }

        function handleMouseDown(e) {
            e.stopPropagation()
            isMouseDown = true
            didDrag = false
            maxDiff = measureMaxDiff()
            lastPageX = isPC ? e.pageX : e.touches[0]?.pageX

            ele.parentElement?.addEventListener('mousemove', handleBodyMove)
        }

        function handleMouseUp(e) {
            e.stopPropagation()
            isMouseDown = false
            lastPageX = null
            ele.parentElement?.removeEventListener('mousemove', handleBodyMove)
            // 拖动后吞掉紧随其后的 click，避免误切色号
            if (didDrag) {
                const swallow = (ev) => {
                    ev.preventDefault()
                    ev.stopPropagation()
                    ele.removeEventListener('click', swallow, true)
                }
                ele.addEventListener('click', swallow, true)
                setTimeout(() => ele.removeEventListener('click', swallow, true), 0)
            }
        }

        function handleMouseMove(e) {
            if (!isMouseDown || lastPageX === null) return
            e.stopPropagation()
            if (e.cancelable) e.preventDefault()
            const curPageX = isPC ? e.pageX : e.touches[0]?.pageX
            const diff = lastPageX - curPageX
            if (Math.abs(diff) > 2) didDrag = true
            translateX = Math.max(Math.min(0, translateX - diff), maxDiff)
            moveEle.style.transform = `translateX(${translateX}px)`
            lastPageX = curPageX
            updateStatusOfArrow(eleForArrow, translateX)
        }
        
        
        function initArrow(arrowRoot) {
            if (!arrowRoot) return
            if (![...arrowRoot.children]?.some((child) => String(child.className).indexOf('arrow') >= 0)) {
                return
            }

            const leftArrow = arrowRoot.querySelector('.arrow.left')
            const rightArrow = arrowRoot.querySelector('.arrow.right')
            if (!leftArrow || !rightArrow) return

            leftArrow.classList.add('disabled')
            leftArrow.classList.remove('hidden')
            rightArrow.classList.remove('hidden')
            requestAnimationFrame(function () {
                maxDiff = measureMaxDiff()
                updateStatusOfArrow(arrowRoot, translateX)
            })

            leftArrow.onclick = handleArrowClick('left', arrowRoot)
            rightArrow.onclick = handleArrowClick('right', arrowRoot)
        }

        function recoverArrow(ele) {
            if (!ele) return
            if (![...ele.children]?.some((child) => child.className.indexOf('arrow') >= 0)) {
                return
            }

            const leftArrow = ele.querySelector('.arrow.left'), rightArrow = ele.querySelector('.arrow.right')
            if (leftArrow.className.indexOf('hidden') < 0) {
                leftArrow.classList.add('hidden')
            }
            if (rightArrow.className.indexOf('hidden') < 0) {
                rightArrow.classList.add('hidden')
            }
            leftArrow.removeEventListener('click', handleArrowClick('left', ele))
            rightArrow.removeEventListener('click', handleArrowClick('right', ele))
        }
        
        function updateStatusOfArrow(parentEle, translateX) {
            if (!parentEle) return
            const leftArrowDom = parentEle.querySelector('.arrow.left'), rightArrowDom = parentEle.querySelector('.arrow.right')
            if (translateX <= maxDiff) {
                if (leftArrowDom.className.indexOf('disabled') >= 0) {
                    leftArrowDom.classList.remove('disabled')
                }
                if (rightArrowDom.className.indexOf('disabled') >= 0) return
                rightArrowDom.classList.add('disabled')
            } else if (translateX === 0) {
                if (rightArrowDom.className.indexOf('disabled') >= 0) {
                    rightArrowDom.classList.remove('disabled')
                }
                if (leftArrowDom.className.indexOf('disabled') >= 0) return
                leftArrowDom.classList.add('disabled')
            } else {
                if (rightArrowDom.className.indexOf('disabled') >= 0) {
                    rightArrowDom.classList.remove('disabled')
                }
                if (leftArrowDom.className.indexOf('disabled') >= 0) {
                    leftArrowDom.classList.remove('disabled')
                }
            }
        }
        
        function handleArrowClick(direction) {
            return function (e) {
                e.preventDefault()
                e.stopPropagation()
                maxDiff = measureMaxDiff()
                const step = Math.max(parentEle.clientWidth * 0.7, 48)
                const isLeftBtn = direction === 'left'
                translateX = translateX + (isLeftBtn ? step : -step)
                translateX = Math.max(Math.min(0, translateX), maxDiff)
                moveEle.style.transform = `translateX(${translateX}px)`
                updateStatusOfArrow(eleForArrow, translateX)
            }
        }

        // 先清掉上次绑定留下的 transform，再重新测量
        moveEle.style.transform = ''
        translateX = 0
        maxDiff = measureMaxDiff()

        if (ele && maxDiff < -2) {
            initArrow(eleForArrow)
            moveEle.style.justifyContent = 'flex-start'

            if (isPC) {
                ele.removeEventListener('mousedown', handleMouseDown)
                ele.removeEventListener('mousemove', handleMouseMove)
                ele.removeEventListener('mouseup', handleMouseUp)
                ancestor.removeEventListener('mouseleave', handleMouseUp)

                ele.addEventListener('mousedown', handleMouseDown)
                ele.addEventListener('mousemove', handleMouseMove)
                ele.addEventListener('mouseup', handleMouseUp)
                ancestor.addEventListener('mouseleave', handleMouseUp)
            } else {
                ele.removeEventListener('touchstart', handleMouseDown)
                ele.removeEventListener('touchmove', handleMouseMove)
                ele.removeEventListener('touchend', handleMouseUp)
                ancestor.removeEventListener('mouseleave', handleMouseUp)

                ele.addEventListener('touchstart', handleMouseDown, { passive: true })
                ele.addEventListener('touchmove', handleMouseMove, { passive: false })
                ele.addEventListener('touchend', handleMouseUp)
                ancestor.addEventListener('mouseleave', handleMouseUp)
            }
        } else {
            recoverArrow(eleForArrow)
            moveEle.style.transform = ''
        }
    }

    function scheduleVisibleInit(el) {
        if (!el || el.inited) return;

        const run = () => {
            if (typeof el.init === 'function') el.init();
        };

        if (!('IntersectionObserver' in window)) {
            requestAnimationFrame(run);
            return;
        }

        const io = new IntersectionObserver((entries) => {
            if (!entries.some((entry) => entry.isIntersecting)) return;
            io.disconnect();
            requestAnimationFrame(run);
        }, { rootMargin: '120px 0px' });
        io.observe(el);
    }

    let resizeTimer = 0;
    window.addEventListener('resize', () => {
        if (resizeTimer) return;
        resizeTimer = window.setTimeout(() => {
            resizeTimer = 0;
            document.querySelectorAll('pcard-color-swatch').forEach((node) => {
                if (!node.inited) return;
                handleColorListMouseMove(node);
            });
        }, 150);
    });

    class PCardColorSwatch extends HTMLElement {
        constructor() {
            super()
            this.inited = false
        }

        connectedCallback() {
            this.addEventListener('click', this.updateByobLinkFromSwatch.bind(this))

            if (this.dataset.inCartDrawer) {
                const drawerDom = document.querySelector('cart-drawer')
                if (drawerDom) {
                    drawerDom.addEventListener(drawerDom.events.handleAfterShow, () => {
                        this.init()
                    })
                }
                return
            }

            if (this.dataset.switchTabIndex) {
                const switchTabIndex = this.dataset.switchTabIndex
                const tabComponent = this.closest('tabs-component')
                if (tabComponent) {
                    tabComponent.addEventListener('tabChange', (e) => {
                        const {selectedIndex} = e.detail
                        if (String(selectedIndex) === switchTabIndex) {
                            this.init()
                        }
                    })
                }
            }

            scheduleVisibleInit(this)
        }

        init() {
            if (this.inited) return
            this.inited = true
            handleColorListMouseMove(this)
        }

        updateByobLinkFromSwatch(e) {
            const swatch = e.target.closest('.swatch-color')
            if (!swatch) return
            const inputDom = swatch.parentElement?.querySelector('input')
            const variantId = inputDom?.dataset?.id
            if (!variantId) return
            const productCard = this.closest('.product-card')
            const byobLinks = productCard?.querySelectorAll('[data-byob-link]')
            byobLinks?.forEach((dom) => {
                const baseUrl = dom.dataset.byobBaseUrl || dom.href.split('?')[0]
                const separator = baseUrl.includes('?') ? '&' : '?'
                dom.href = `${baseUrl}${separator}byob_variant=${variantId}`
                dom.dataset.byobVariantId = variantId
            })
        }
    }
    customElements.define('pcard-color-swatch', PCardColorSwatch);
})()
